<template>
  <l-cache :get-data="getEvent" :id="$route.query.id">
    <template slot-scope="{data}">
      <violation-detail-content :event="data">
        <template slot="append">
          <final-predict-form :event="data"></final-predict-form>
        </template>
        <template slot="action">
          <v-flex layout justify-end class="pt-2">
            <v-btn :loading="revokeLoading" color="error" @click="revokeEvent(data)">撤销违章</v-btn>
            <v-btn :loading="confirmLoading" class="mx-0" color="primary" @click="finalConfirm(data)">确认并发送</v-btn>
          </v-flex>
        </template>
      </violation-detail-content>
      <v-dialog v-model="successDialog.activate" scrollable persistent max-width="800px">
        <view-send-message-content
          title="处理成功"
          @cancel="goReadonly()"
          @confirm="returnToList()"
        ></view-send-message-content>
      </v-dialog>
    </template>
  </l-cache>
</template>
<script>

import ViolationDetailContent from './violationDetailContent'
import {VIOLATION_ROLE} from '../../../object'
import ViewSendMessageContent from './viewSendMessageContent'
import FinalPredictForm from './finalPredictForm'

export default {
  // 最终确认
  name: 'ViolationEventConfirm',
  components: {FinalPredictForm, ViewSendMessageContent, ViolationDetailContent},
  data: () => ({
    VIOLATION_ROLE,
    successDialog: {
      activate: false,
      messages: []
    },
    revokeLoading: false,
    confirmLoading: false
  }),
  computed: {},
  methods: {
    closeSuccessDialog () {
      this.successDialog = {
        activate: false,
        messages: []
      }
    },
    async finalConfirm (event) {
      // Fixme 补全发信逻辑 考虑需要再次预测
      let {res, close} = await this.$L.confirm({
        title: '确认并发送短信',
        text: `确认 ${event.plate} 违章并发送短信？`,
        subText: ``
      })
      console.log(res)
      if (res) {
        try {
          this.confirmLoading = true
          let msg = await this.$store.dispatch('violation/finalConfirm', event)
          this.$L.success('提交成功')
          this.$L.tab.close(this.$route.fullPath)
          this.$router.push({
            name: 'ViolationEventManagement',
            params: {refresh: true}
          })
          // 不用显示预测直接返回
          // this.openSuccessDialog(msg)
        }
        catch (e) {
          this.$L.error(e.message)
        }
        finally {
          this.confirmLoading = false
        }
      }
      close()
    },
    async revokeEvent (event) {
      let {res, close} = await this.$L.confirm({
        title: '确认撤销',
        text: '确认撤销此违章？'
      })
      if (res) {
        try {
          this.revokeLoading = true
          await this.$store.dispatch('violation/revokeEvent', event)
          this.$L.success('撤销成功')
          this.$L.tab.close(this.$L.tab.current, false)
          this.$router.push({
            name: 'ViolationEventManagement',
            params: {refresh: true}
          })
        }
        catch (e) {
          this.$L.error(e.message)
        }
        finally {
          this.revokeLoading = false
        }
      }
      close()
    },
    returnToList () {
      this.closeSuccessDialog()
      this.$L.tab.close(this.$L.tab.current, false)
      this.$router.push({
        name: 'ViolationEventManagement',
        params: {refresh: true}
      })
    },
    goReadonly () {
      this.closeSuccessDialog()
      this.$L.tab.close(this.$L.tab.current, false)
      this.$router.push({
        name: 'ViolationEventDetails',
        params: {plate: this.event.plate},
        query: {id: this.event.id}
      })
    },
    openSuccessDialog () {
      this.successDialog = {
        activate: true
      }
    },
    async getEvent (key) {
      let {items, amount} = await this.$store.dispatch('violation/getEvents', {
        pagination: {},
        search: {key: 'id', value: key}
      })
      if (!amount) {
        throw Error('未找到该事件')
      }
      else {
        return items[0]
      }
    }
  },
  created () {

  }
}
</script>
